module.exports = __webpack_public_path__ + "img/buddy_ears-06.464404ab.svg";